import { Box } from "@dropbox/dig-foundations";
import {
  AiChatLine,
  EditLine,
  SearchLine,
  StacksLine,
} from "@dropbox/dig-icons/assets";
import { ScopedModeChip } from "@mirage/mosaics/Omnibox/components/Omnibar/ScopedButtonRow/ScopedModeChip";
import { typeahead } from "@mirage/service-typeahead-search/service/types";
import i18n from "@mirage/translations";
import classNames from "classnames";
import styles from "./ScopedButtonRow.module.css";

import type { ScopedModeChipProps } from "@mirage/mosaics/Omnibox/components/Omnibar/ScopedButtonRow/ScopedModeChip";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";

type ScopedButtonRowProps = {
  onAttachButtonClicked: () => void;
  onScopedButtonClicked: (mode: typeahead.Mode) => void;
  isResultsOpen: boolean;
  currentScopedMode: typeahead.Mode;
};
export const ScopedButtonRow = ({
  onScopedButtonClicked,
  // onAttachButtonClicked,
  isResultsOpen,
  currentScopedMode,
}: ScopedButtonRowProps) => {
  const isMobile = useIsMobileSize();

  // Note: will assume that if the results/typeahead is open then scoped rows are not interactable
  // we're disabling this so there's no re-rendering
  const disableButtonRow = isResultsOpen;
  // Note: onClickHandler is omitted since a single shared onClickHandler will be used
  const scopedModeChips: Omit<
    ScopedModeChipProps,
    "onClickHandler" | "isSelected"
  >[] = [
    {
      src: SearchLine,
      modeType: typeahead.Mode.Find,
      chipLabel: i18n.t("omnibox_chip_find"),
    },
    {
      src: AiChatLine,
      modeType: typeahead.Mode.Ask,
      chipLabel: i18n.t("omnibox_chip_ask"),
    },
    {
      src: EditLine,
      modeType: typeahead.Mode.Write,
      chipLabel: i18n.t("omnibox_chip_write"),
    },
    {
      src: StacksLine,
      modeType: typeahead.Mode.Organize,
      chipLabel: i18n.t("omnibox_chip_organize"),
    },
  ];

  return (
    <Box
      className={classNames(styles.scopedButtonsBoxRow, {
        [styles.disableButtonRow]: disableButtonRow,
        [styles.mobile]: isMobile,
      })}
    >
      {/* OSE-5161 */}
      {/*<IconButton*/}
      {/*  variant="opacity"*/}
      {/*  shape="circular"*/}
      {/*  onClick={onAttachButtonClicked}*/}
      {/*  // TEMP disable this until we have functionality for attachements*/}
      {/*  disabled={true || disableButtonRow}*/}
      {/*>*/}
      {/*  /!* TODO: OSE-5085 add tooltip & a11y label*!/*/}
      {/*  <UIIcon src={AddLine} aria-label="attach a document" />*/}
      {/*</IconButton>*/}

      {scopedModeChips.map(({ src, modeType, chipLabel }) => (
        <ScopedModeChip
          key={modeType}
          src={src}
          modeType={modeType}
          chipLabel={chipLabel}
          onClickHandler={() => onScopedButtonClicked(modeType)}
          disabled={disableButtonRow}
          isSelected={modeType === currentScopedMode}
        />
      ))}
    </Box>
  );
};
